import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function GestionCookiesPage() {
  const handleDownload = () => {
    const content = document.getElementById('legal-content');
    if (!content) return;

    // Créer le contenu HTML pour l'impression
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <title>Politique de Gestion des Cookies - Clinique Sainte Famille</title>
          <style>
            @page { 
              margin: 2cm; 
              size: A4;
            }
            body { 
              font-family: Arial, sans-serif; 
              padding: 0; 
              margin: 0;
              line-height: 1.6; 
              color: #333; 
              font-size: 12px;
            }
            h1 { 
              color: #1e40af; 
              font-size: 24px; 
              margin-bottom: 20px; 
              page-break-after: avoid;
            }
            h2 { 
              color: #1e40af; 
              font-size: 18px; 
              margin-top: 25px; 
              margin-bottom: 12px; 
              page-break-after: avoid;
            }
            h3 { 
              color: #1e40af; 
              font-size: 14px; 
              margin-top: 15px; 
              margin-bottom: 8px; 
              page-break-after: avoid;
            }
            h4 { 
              color: #1e40af; 
              font-size: 12px; 
              margin-top: 10px; 
              margin-bottom: 6px; 
              page-break-after: avoid;
            }
            p, li { 
              margin-bottom: 8px; 
              page-break-inside: avoid;
            }
            ul { 
              margin-left: 20px; 
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin: 15px 0; 
              page-break-inside: avoid;
            }
            th, td { 
              border: 1px solid #ddd; 
              padding: 6px; 
              text-align: left; 
              font-size: 11px;
            }
            th { 
              background-color: #f3f4f6; 
            }
            .info-box { 
              background: #f8f9fa; 
              padding: 12px; 
              border-left: 4px solid #1e40af;
              margin: 12px 0; 
              page-break-inside: avoid;
            }
            .grid { 
              display: block; 
            }
            .grid > div { 
              margin-bottom: 10px; 
              page-break-inside: avoid;
            }
            section { 
              page-break-inside: avoid; 
              margin-bottom: 20px;
            }
            @media print {
              body { print-color-adjust: exact; }
            }
          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `;

    // Créer un blob avec le contenu
    const blob = new Blob([printContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    
    // Ouvrir dans une nouvelle fenêtre pour l'impression
    const printWindow = window.open(url, '_blank', 'width=800,height=600');
    
    if (printWindow) {
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          printWindow.onafterprint = () => {
            printWindow.close();
            URL.revokeObjectURL(url);
          };
        }, 500);
      };
    } else {
      // Fallback : téléchargement direct du fichier
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Politique-Gestion-Cookies-Clinique-Sainte-Famille.html';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      <div className="flex-1 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-6 py-3 bg-clinic-blue text-white rounded-full hover:bg-clinic-blue-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line text-lg"></i>
              Télécharger en PDF
            </button>
          </div>
          <div className="bg-white rounded-3xl shadow-xl border-2 border-clinic-blue/10 p-8 md:p-12" id="legal-content">
            <div className="mb-8">
              <div className="w-16 h-16 bg-clinic-blue/10 rounded-2xl flex items-center justify-center mb-4">
                <i className="ri-checkbox-circle-line text-3xl text-clinic-blue"></i>
              </div>
              <h1 className="text-4xl font-bold text-clinic-blue-dark mb-2">Politique de Gestion des Cookies</h1>
              <p className="text-gray-600">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            </div>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">1. Qu'est-ce qu'un Cookie ?</h2>
                <p className="text-gray-700 mb-4">
                  Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) 
                  lors de la visite d'un site internet. Il permet de collecter des informations relatives à votre navigation 
                  et de vous proposer des services adaptés.
                </p>
                <div className="bg-clinic-blue/5 border-l-4 border-clinic-blue p-4 rounded-lg">
                  <p className="text-sm text-clinic-blue-dark">
                    <i className="ri-information-line mr-2"></i>
                    Les cookies ne peuvent pas endommager votre appareil et ne contiennent pas de virus.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">2. Types de Cookies Utilisés</h2>
                
                <div className="space-y-4">
                  <div className="bg-clinic-green/10 border-2 border-clinic-green/30 p-6 rounded-2xl">
                    <h3 className="font-semibold text-clinic-blue-dark mb-3 flex items-center">
                      <i className="ri-shield-check-line mr-2 text-clinic-green"></i>
                      2.1 Cookies Strictement Nécessaires
                    </h3>
                    <p className="text-gray-700 mb-3">
                      Ces cookies sont indispensables au fonctionnement de la plateforme et à la sécurité de vos données médicales. 
                      Ils ne peuvent pas être désactivés.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li><strong>Authentification :</strong> Maintien de votre session de connexion sécurisée</li>
                      <li><strong>Sécurité :</strong> Protection contre les attaques et accès non autorisés</li>
                      <li><strong>Fonctionnalité :</strong> Mémorisation de vos préférences essentielles</li>
                    </ul>
                    <div className="bg-white/50 p-3 rounded-lg mt-3">
                      <p className="text-sm text-gray-600">
                        <strong>Durée de conservation :</strong> Session ou jusqu'à 30 jours maximum
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-200">
                    <h3 className="font-semibold text-clinic-blue-dark mb-3 flex items-center">
                      <i className="ri-settings-3-line mr-2 text-clinic-blue"></i>
                      2.2 Cookies de Fonctionnalité
                    </h3>
                    <p className="text-gray-700 mb-3">
                      Ces cookies permettent d'améliorer votre expérience utilisateur en mémorisant vos préférences.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Langue préférée</li>
                      <li>Préférences d'affichage</li>
                      <li>Paramètres de notification</li>
                    </ul>
                    <div className="bg-white p-3 rounded-lg mt-3">
                      <p className="text-sm text-gray-600">
                        <strong>Durée de conservation :</strong> Jusqu'à 12 mois
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-200">
                    <h3 className="font-semibold text-clinic-blue-dark mb-3 flex items-center">
                      <i className="ri-bar-chart-line mr-2 text-clinic-blue"></i>
                      2.3 Cookies Analytiques
                    </h3>
                    <p className="text-gray-700 mb-3">
                      Ces cookies nous aident à comprendre comment vous utilisez la plateforme pour l'améliorer.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-1">
                      <li>Pages visitées et temps passé</li>
                      <li>Parcours de navigation</li>
                      <li>Erreurs rencontrées</li>
                    </ul>
                    <div className="bg-white p-3 rounded-lg mt-3">
                      <p className="text-sm text-gray-600">
                        <strong>Durée de conservation :</strong> Jusqu'à 24 mois
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">3. Cookies Tiers</h2>
                <p className="text-gray-700 mb-4">
                  Notre plateforme peut utiliser des services tiers qui déposent leurs propres cookies :
                </p>
                <div className="bg-gray-50 p-6 rounded-2xl space-y-3">
                  <div>
                    <p className="font-semibold text-clinic-blue-dark mb-1">Supabase (Hébergement et Authentification)</p>
                    <p className="text-sm text-gray-700">Cookies nécessaires pour l'authentification sécurisée et le stockage des données médicales</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">4. Gestion de Vos Cookies</h2>
                
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-clinic-blue-dark mb-3">4.1 Paramétrage du Navigateur</h3>
                    <p className="text-gray-700 mb-3">
                      Vous pouvez configurer votre navigateur pour gérer les cookies selon vos préférences :
                    </p>
                    
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="bg-white border-2 border-clinic-blue/20 p-4 rounded-2xl">
                        <h4 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                          <i className="ri-chrome-line mr-2 text-clinic-blue"></i>
                          Google Chrome
                        </h4>
                        <p className="text-sm text-gray-700">Paramètres &gt; Confidentialité et sécurité &gt; Cookies</p>
                      </div>

                      <div className="bg-white border-2 border-clinic-blue/20 p-4 rounded-2xl">
                        <h4 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                          <i className="ri-firefox-line mr-2 text-clinic-blue"></i>
                          Mozilla Firefox
                        </h4>
                        <p className="text-sm text-gray-700">Options &gt; Vie privée et sécurité &gt; Cookies</p>
                      </div>

                      <div className="bg-white border-2 border-clinic-blue/20 p-4 rounded-2xl">
                        <h4 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                          <i className="ri-safari-line mr-2 text-clinic-blue"></i>
                          Safari
                        </h4>
                        <p className="text-sm text-gray-700">Préférences &gt; Confidentialité &gt; Cookies</p>
                      </div>

                      <div className="bg-white border-2 border-clinic-blue/20 p-4 rounded-2xl">
                        <h4 className="font-semibold text-clinic-blue-dark mb-2 flex items-center">
                          <i className="ri-edge-line mr-2 text-clinic-blue"></i>
                          Microsoft Edge
                        </h4>
                        <p className="text-sm text-gray-700">Paramètres &gt; Confidentialité &gt; Cookies</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg">
                    <p className="text-sm text-yellow-800">
                      <i className="ri-alert-line mr-2"></i>
                      <strong>Attention :</strong> La désactivation de certains cookies peut affecter le fonctionnement 
                      de la plateforme et limiter l'accès à certains services, notamment la gestion de votre dossier médical.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">5. Cookies et Données Médicales</h2>
                <div className="bg-clinic-blue/5 border-2 border-clinic-blue/20 p-6 rounded-2xl">
                  <p className="text-gray-700 mb-3">
                    <strong>Protection renforcée :</strong> Les cookies utilisés pour accéder à vos données médicales 
                    bénéficient d'une protection renforcée conformément à la loi n°2017-20 du Bénin.
                  </p>
                  <ul className="list-disc list-inside text-gray-700 space-y-2">
                    <li>Chiffrement des données de session</li>
                    <li>Expiration automatique après inactivité</li>
                    <li>Journalisation des accès pour traçabilité</li>
                    <li>Aucune donnée médicale stockée dans les cookies</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">6. Durée de Conservation</h2>
                <div className="bg-gray-50 p-6 rounded-2xl overflow-x-auto">
                  <table className="w-full text-sm min-w-[420px]">
                    <thead>
                      <tr className="border-b-2 border-gray-300">
                        <th className="text-left py-2 text-clinic-blue-dark">Type de Cookie</th>
                        <th className="text-left py-2 text-clinic-blue-dark">Durée Maximale</th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-700">
                      <tr className="border-b border-gray-200">
                        <td className="py-2">Session (authentification)</td>
                        <td className="py-2">Jusqu'à la déconnexion</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="py-2">Sécurité</td>
                        <td className="py-2">30 jours</td>
                      </tr>
                      <tr className="border-b border-gray-200">
                        <td className="py-2">Préférences</td>
                        <td className="py-2">12 mois</td>
                      </tr>
                      <tr>
                        <td className="py-2">Analytiques</td>
                        <td className="py-2">24 mois</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">7. Vos Droits</h2>
                <p className="text-gray-700 mb-4">
                  Conformément à la loi n°2017-20 du Bénin sur la protection des données personnelles, vous disposez des droits suivants :
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Droit d'accès aux informations collectées via les cookies</li>
                  <li>Droit de refuser les cookies non essentiels</li>
                  <li>Droit de supprimer les cookies à tout moment</li>
                  <li>Droit d'opposition au traçage de votre navigation</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">8. Modifications</h2>
                <p className="text-gray-700">
                  Cette politique de cookies peut être mise à jour pour refléter les évolutions de nos pratiques 
                  ou de la réglementation. Nous vous informerons de toute modification substantielle.
                </p>
              </section>

              <section className="bg-clinic-blue/5 p-6 rounded-2xl border-2 border-clinic-blue/20">
                <h2 className="text-2xl font-bold text-clinic-blue-dark mb-4">Contact</h2>
                <p className="text-gray-700 mb-4">
                  Pour toute question concernant notre utilisation des cookies :
                </p>
                <div className="space-y-2 text-gray-700">
                  <p><i className="ri-mail-line mr-2 text-clinic-blue"></i><strong>Email :</strong> clinicfam@yahoo.com</p>
                  <p><i className="ri-phone-line mr-2 text-clinic-blue"></i><strong>Téléphone :</strong> +229 01 95 40 58 91</p>
                  <p><i className="ri-map-pin-line mr-2 text-clinic-blue"></i><strong>Adresse :</strong> 99QX+7W, Cotonou Bénin - 04 BP 127 lot 1862 Fifadji</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
